import OrangeKitSafeFactoryMainnetArtifact from "@mezo-org/orangekit-contracts/deployments/mainnet/OrangeKitSafeFactory.json";
import OrangeKitSafeFactorySepoliaArtifact from "@mezo-org/orangekit-contracts/deployments/sepolia/OrangeKitSafeFactory.json";
import OrangeKitSafeFactoryLocalhostArtifact from "@mezo-org/orangekit-contracts/deployments/localhost/OrangeKitSafeFactory.json";
import OrangeKitSafeFactoryMatsnetArtifact from "@mezo-org/orangekit-contracts/deployments/matsnet/OrangeKitSafeFactory.json";
import { encodeFunctionData, getAddress, } from "viem";
import { ContractWrapper } from "./contract";
// eslint-disable-next-line import/prefer-default-export
export class EthereumOrangeKitSafeFactory extends ContractWrapper {
    constructor(config, network) {
        let artifact;
        switch (network) {
            case "mainnet":
                artifact = {
                    ...OrangeKitSafeFactoryMainnetArtifact,
                    receipt: { blockNumber: 19512821 },
                };
                break;
            case "sepolia":
                artifact = {
                    ...OrangeKitSafeFactorySepoliaArtifact,
                    receipt: { blockNumber: 5559111 },
                };
                break;
            case "hardhat":
                artifact = {
                    ...OrangeKitSafeFactoryLocalhostArtifact,
                    receipt: { blockNumber: 19512821 },
                };
                break;
            case "matsnet-testnet":
                artifact = {
                    ...OrangeKitSafeFactoryMatsnetArtifact,
                    receipt: { blockNumber: 816571 },
                };
                break;
            default:
                throw new Error("Unsupported network");
        }
        super(config, artifact);
    }
    async predictAddress(truncatedBitcoinAddress) {
        // TODO: We should use the create2 address prediction tools provided by viem.
        const addresses = (await this.instance.read.predictAddresses([
            truncatedBitcoinAddress,
        ]));
        return getAddress(addresses[0]);
    }
    async populateSafeDeploymentTransaction(truncatedBitcoinAddress) {
        const to = this.getAddress();
        const data = encodeFunctionData({
            abi: this.getAbi(),
            functionName: "deploySafe",
            args: [truncatedBitcoinAddress],
        });
        return { to, data };
    }
    async simulateSafeDeploymentTransaction(truncatedBitcoinAddress, from) {
        const client = this.getClient();
        try {
            const response = await client.simulateContract({
                address: this.getAddress(),
                abi: this.getAbi(),
                functionName: "deploySafe",
                args: [truncatedBitcoinAddress],
                account: from,
            });
            return !!response.result;
        }
        catch (error) {
            if (error instanceof Error) {
                throw new Error(`Safe deployment transaction simulation failed: ${error.message}`);
            }
            throw new Error("Safe deployment transaction simulation failed");
        }
    }
}
//# sourceMappingURL=safe-factory.js.map